<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <MessageSquareIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('news.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link :to="{ name: 'superadmin-tools-news-add' }">
          <button class="btn btn-primary shadow-md mr-2">
            {{ $t('news.add') }}
          </button>
        </router-link>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <NewsListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import NewsListTable from '@/components/news/NewsListTable'

export default defineComponent({
  components: {
    NewsListTable
  },
  setup() {
    return {}
  }
})
</script>
